import { useState } from 'react'
import { ModalBtn } from './ModalBtn'
import { Grower, GrowerField, GrowersList } from '../../interfaces/interfaces.auth'
import { useDispatch } from 'react-redux'
import { startChecking } from '../../store/asyncMethods/authMethods'
import { hasLength } from '../../helpers/validators'
import toast from 'react-hot-toast'
import { useCreateField, useEditField } from '../../api/useGrower'

interface Props {
    target: GrowersList
    grower: Grower
    field?: GrowerField
    closeModal: () => void
}

export const ModalAddField = ({ closeModal, grower, target, field }: Props) => {

    const dispatch = useDispatch()

    const [name, setName] = useState(field?.name || "")
    const [country, setCountry] = useState(field?.country || "")
    const [city, setCity] = useState(field?.city || "")
    const [coords, setCoords] = useState<{ lat: string, lon: string }>({ lat: field?.coords.lat.toString() || "", lon: field?.coords.lon.toString() || "" })

    const { mutate, isLoading } = useCreateField()
    const { mutate: mutateEditField, isLoading: isEditing } = useEditField()

    const addField = () => {

        const cleanName = name.trim()
        const cleanCountry = country.trim()
        const cleanCity = city.trim()

        if ((field
            ? grower.fields.filter(f => f.name.trim() !== field?.name) //Si viene field
            : grower.fields)
            .find(grow => grow.name.trim() === cleanName))
            return toast.error("Field already exists")

        if (!hasLength(cleanName) || !hasLength(cleanCountry) || !hasLength(cleanCity)) return toast.error("Please fill in all fields")

        const payload = {
            id: target.id,
            model: target.model,
            growerId: grower._id,
            name: cleanName,
            country: cleanCountry,
            city: cleanCity,
            coords: {
                lat: Number(coords.lat),
                lon: Number(coords.lon)
            }
        }

        field ?
            mutateEditField({
                ...payload, fieldId: field._id
            }, {
                onSuccess: async () => {
                    dispatch(startChecking())
                    closeModal()
                },
                onError: (error) => console.log(error)
            })


            : mutate(payload, {
                onSuccess: async () => {
                    dispatch(startChecking())
                    closeModal()
                },
                onError: (error) => console.log(error)
            })
    };

    const handleCoordsInput = (idx: "lat" | "lon", value: string) => {
        const next = { ...coords };
        next[idx] = value;
        setCoords(next);
    };

    const handleCoords = () => {
        const lat = Number(coords.lat);
        const lon = Number(coords.lon);

        if (Number.isNaN(lat) || Number.isNaN(lon)) return;
    };

    return (

        <div className="modal">

            <div className="modal__card">
                <div className="modal__content tw-gap-4">
                    <div>
                        <p className='font-normal mb-02 ml-02'>Name</p>
                        <input
                            className="tw-w-full"
                            type="text"
                            value={name}
                            maxLength={30}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                    <div>
                        <p className='font-normal mb-02 ml-02'>Country</p>
                        <input
                            className="tw-w-full"
                            type="text"
                            value={country}
                            maxLength={20}
                            onChange={(e) => setCountry(e.target.value)}
                        />
                    </div>
                    <div>
                        <p className='font-normal mb-02 ml-02'>City</p>
                        <input
                            className="tw-w-full"
                            type="text"
                            value={city}
                            maxLength={30}
                            onChange={(e) => setCity(e.target.value)}
                        />
                    </div>
                    <div className='tw-grid tw-grid-cols-2 tw-gap-2'>
                        <div>
                            <p className='font-normal mb-02 ml-02'>Latitude</p>
                            <input
                                type="number"
                                step="any"
                                className="tw-w-full tw-h-10"
                                value={coords.lat}
                                onChange={e => handleCoordsInput("lat", e.target.value)}
                                onFocus={e => e.target.select()}
                                onBlur={handleCoords}

                            />
                        </div>
                        <div>
                            <p className='font-normal mb-02 ml-02'>Longitude</p>
                            <input
                                type="number"
                                step="any"
                                className="tw-w-full tw-h-10"
                                value={coords.lon}
                                onChange={e => handleCoordsInput("lon", e.target.value)}
                                onFocus={e => e.target.select()}
                                onBlur={handleCoords}

                            />
                        </div>
                    </div>

                    <ModalBtn
                        action={addField}
                        closeModal={closeModal}
                        actionTitle={`${field ? 'Edit Field' : 'Add Field'}`}
                        isLoading={isLoading || isEditing}
                    />

                </div>
            </div>
        </div>

    )
}
